module.exports = __webpack_public_path__ + "img/3.d38c7a1e.jpg";